<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="container mt-4">
        <Permissioned section="bookings" :id="currentBookingId">
          <div permission="edit.options">
            <h3 class="mb-2">Profile Sections</h3>
            <p>
              The sections that a user will be asked to complete when they apply
              for the role
            </p>
            <Checkbox
              @change="handleChange"
              :selected-values="initialData"
              :options="items"
              isLarge
              mixed
            />
          </div>
        </Permissioned>
        <Permissioned section="bookings" :id="currentBookingId">
          <div permission="edit.application-questions" class="full-width">
            <h3 class="mb-2">Application Questions</h3>
            <EditableApplicationQuestions
              title="Screening Questions"
              :existingQuestions="screeningQuestions"
              ref="screeningQuestions"
            />
            <EditableApplicationQuestions
              title="Standard Questions"
              :existingQuestions="standardQuestions"
              ref="standardQuestions"
            />
          </div>
        </Permissioned>
      </div>
    </template>
    <template v-slot:dialog.action>
      <v-spacer />
      <PrimaryButton @click.native="save" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import { createNamespacedHelpers } from "vuex";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import {
  EDIT_BOOKING_OPTIONS,
  BOOKINGS_NAMESPACE
} from "@/store/modules/bookings/actions";
import { BOOKING_OPTIONS } from "@/constants/bookings";
import Checkbox from "@/components/common/Checkbox";
import { map } from "lodash";
import Permissioned from "@/components/common/Permissioned";
import EditableApplicationQuestions from "@/components/application-questions/EditableApplicationQuestions";
import { isPermissioned } from "@/utils/permissions";
import { addSuccessMessage } from "@/services/utils";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "EditShifts",
  components: {
    PrimaryButton,
    DialogFull,
    Checkbox,
    Permissioned,
    EditableApplicationQuestions
  },
  data() {
    return {
      isLoading: false,
      selectedOptions: {},
      items: BOOKING_OPTIONS
    };
  },
  computed: {
    dialogSettings() {
      return {
        title: "Edit Application Form",
        dialog: this.isOpen
      };
    },
    currentBookingId() {
      return this.$route.params.id;
    },
    initialData() {
      return [
        this.bookingOptions.requireCv && "requireCv",
        this.bookingOptions.requireExperience && "requireExperience",
        this.bookingOptions.requireQualifications && "requireQualifications"
      ].filter(Boolean);
    },
    canEditBookingOptions() {
      return isPermissioned(`bookings[${this.currentBookingId}].edit.options`);
    },
    canEditBookingApplicationQuestions() {
      return isPermissioned(
        `bookings[${this.currentBookingId}].edit.application-questions`
      );
    }
  },
  props: {
    isOpen: Boolean,
    bookingOptions: Object,
    screeningQuestions: Array,
    standardQuestions: Array
  },
  methods: {
    ...mapActions({
      editBookingOptions: EDIT_BOOKING_OPTIONS
    }),
    async save() {
      this.isLoading = true;
      if (this.canEditBookingOptions) {
        await this.editBookingOptions({
          bookingId: this.currentBookingId,
          data: { attributes: this.selectedOptions }
        });
      }
      if (this.canEditBookingApplicationQuestions) {
        await this.$refs.screeningQuestions.handleSubmit();
        await this.$refs.standardQuestions.handleSubmit();
      }
      addSuccessMessage();
      this.isLoading = false;
      this.close();
    },
    handleChange(values) {
      this.selectedOptions = {
        requireCv: false,
        requireExperience: false,
        requireQualifications: false
      };
      map(values, value => {
        this.selectedOptions[value] = true;
      });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
